import React, {useEffect, useState} from 'react';
import FadeSlideIn from "../../common/FadeSlideIn";
import {useLazyQuery} from "@apollo/client";
import {HOMEPAGE_VIDEOS, HOMEPAGE_VIDEOS_CSGO, HOMEPAGE_VIDEOS_GAMBLES} from "../../../queries/queries";
import landingYoutubesHeader from "../../../resources/youtubeHighlights.png";

const LandingYouTube = () => {
    const [videos, setVideos] = useState([]);
    const [primaryVideo, setPrimaryVideo] = useState(null);
    const [primaryVideoTwo, setPrimaryVideoTwo] = useState(null);
    const [primaryVideoThree, setPrimaryVideoThree] = useState(null);

    const [getVideos] = useLazyQuery(HOMEPAGE_VIDEOS, {
        variables: {
            limit: 1,
        },
        fetchPolicy: 'cache-and-network',
        onCompleted: (e) => {
            setPrimaryVideo(e.getVideos[0]);
        },
        onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });
    const [getVideosGambles] = useLazyQuery(HOMEPAGE_VIDEOS_GAMBLES, {
        variables: {
            limit: 1,
        },
        fetchPolicy: 'cache-and-network',
        onCompleted: (e) => {
            setPrimaryVideoTwo(e.getVideosGambles[0]);
        },
        onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const [getVideosGamblesCsgo] = useLazyQuery(HOMEPAGE_VIDEOS_CSGO, {
        variables: {
            limit: 1,
        },
        fetchPolicy: 'cache-and-network',
        onCompleted: (e) => {
            setPrimaryVideoThree(e.getVideosCsgo[0]);
        },
        onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    useEffect(() => {
        getVideos();
        getVideosGambles();
        getVideosGamblesCsgo();
    }, []);

    return (<FadeSlideIn>
        <div className="landingYoutubes">
            <div className="container">
                <div className="landingYoutubesOuter">

                    <p className={'headerMaintext'}>YOUTUBE</p>
                    <img src={landingYoutubesHeader} alt=""/>

                    <div className="otherVideos">

                        {primaryVideo && <div className="videoBig">
                            <a href={`https://www.youtube.com/watch?v=${primaryVideo.id}`} target={'_blank'}>
                                <img src={primaryVideo.thumbnail} alt=""/>
                                <p className={'headerSecondText'}>{primaryVideo.title}</p>
                            </a>
                            <a href="https://www.youtube.com/@Kazlicc" target={'_blank'} className="btn btn-kaz">GO TO
                                MAIN CHANNEL</a>
                        </div>}

                        {primaryVideoTwo && <div className="videoBig">
                            <a href={`https://www.youtube.com/watch?v=${primaryVideoTwo.id}`} target={'_blank'}>
                                <img src={primaryVideoTwo.thumbnail} alt=""/>
                                <p className={'headerSecondText'}>{primaryVideoTwo.title}</p>
                            </a>
                            <a href="https://www.youtube.com/kazlicgambles" target={'_blank'} className="btn btn-kaz">GO TO
                                UNBOXING CHANNEL</a>
                        </div>}

                        {primaryVideoThree && <div className="videoBig">
                            <a href={`https://www.youtube.com/watch?v=${primaryVideoThree.id}`} target={'_blank'}>
                                <img src={primaryVideoThree.thumbnail} alt=""/>
                                <p className={'headerSecondText'}>{primaryVideoThree.title}</p>
                            </a>
                            <a href="https://www.youtube.com/@KazlicCSGO" target={'_blank'} className="btn btn-kaz">GO TO
                                CSGO CHANNEL</a>
                        </div>}

                    </div>


                </div>
            </div>


        </div>
    </FadeSlideIn>);
}
export default LandingYouTube;